import React from "react";
import {
  Card,
  CardContent,
  CardActionArea,
  Typography,
  Box,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import SyncIcon from "@mui/icons-material/Sync";
import DnsOutlinedIcon from "@mui/icons-material/DnsOutlined";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";

const Logs = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const sections = [
    {
      title: t("pages.logs.productSync.title"),
      icon: <SyncIcon sx={{ fontSize: 40, color: "primary.main" }} />,
      path: "/logs/product-sync",
    },
    {
      title: t("pages.logs.integrationServer.title"),
      icon: <DnsOutlinedIcon sx={{ fontSize: 40, color: "primary.main" }} />,
      path: "/logs/integration-server-logs",
    },
    {
      title: t("pages.logs.createdOrders.title"),
      icon: <ReceiptLongIcon sx={{ fontSize: 40, color: "primary.main" }} />,
      path: "/logs/created-orders",
    },
  ];

  return (
    <Box>
      <Typography variant="h2" sx={{ mb: 3 }}>
        {t("pages.logs.title")}
      </Typography>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(2, 1fr)",
            md: "repeat(3, 1fr)",
          },
          gap: 2,
        }}
      >
        {sections.map((section) => (
          <Card key={section.path} sx={{ height: "100%" }}>
            <CardActionArea
              onClick={() => navigate(section.path)}
              sx={{ height: "100%", p: 2 }}
            >
              <CardContent
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  textAlign: "center",
                  gap: 2,
                }}
              >
                {section.icon}
                <Typography variant="h5" component="div">
                  {section.title}
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        ))}
      </Box>
    </Box>
  );
};

export default Logs;
